import EditorPageSteps from './EditorPageSteps';
import ProjectPageSteps from './ProjectPageSteps';

const steps = {
  editor: EditorPageSteps,
  project: ProjectPageSteps,
};

export default (name: string) => steps[name] || [];
